import { Link } from 'react-router-dom';
import type { OverviewCollectorWithoutInstaller } from '@/api/onderaannemers';

// 'YYYY-MM-DD' → '29/05/2026'. String parts only — no Date (CET shift).
function formatDate(dateStr: string): string {
  const [y, m, d] = dateStr.split('-');
  return y && m && d ? `${d}/${m}/${y}` : dateStr;
}

/** Op-druk collectors with no installer: they cannot go on a PO until an installer is
 *  set, so they are listed here instead of disappearing from the overview. Read-only. */
export function MissingInstallerBlock({ collectors }: { collectors: OverviewCollectorWithoutInstaller[] }) {
  return (
    <section
      aria-labelledby="oa-zonder-installateur"
      className={`mt-4 rounded-xl border p-4 ${collectors.length > 0 ? 'bg-amber-50/60 border-amber-300' : 'bg-white border-gray-100'}`}
    >
      <div className="flex items-center gap-2">
        <h3 id="oa-zonder-installateur" className="text-sm font-semibold text-td-navy">
          Op druk zonder installateur
        </h3>
        {collectors.length > 0 && (
          <span className="text-xs font-semibold bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
            {collectors.length}
          </span>
        )}
      </div>

      {collectors.length === 0 ? (
        <p className="text-xs text-td-muted mt-1">Alle collectoren op druk hebben een installateur.</p>
      ) : (
        <>
          <p className="text-xs text-amber-800 mt-1">
            Deze collectoren staan op druk maar hebben geen installateur. Ze kunnen pas op een
            inkooporder komen nadat er een installateur is ingesteld op de collector.
          </p>
          <ul className="mt-3 divide-y divide-amber-200/70">
            {collectors.map((c) => (
              <li key={c.id} className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
                <Link
                  to={`/project/${c.projectId}?tab=collectoren&collector=${c.id}`}
                  className="font-medium text-td-blue hover:underline"
                >
                  {c.name}
                </Link>
                <span className="text-td-navy">{c.projectName}</span>
                {c.m2 > 0 && <span className="text-td-muted">{Math.round(c.m2)} m²</span>}
                <span className="text-td-muted">op druk {formatDate(c.opDrukDatum)}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
